import React, {createContext, useState, useContext} from "react"
import axios from "axios"


import { hvnUriRoot } from "../core/defines"
const newApiRoot = "https://api.marineblue-g.com"


// 20240301 フッター予約ボタンの都合で状態管理・共有範囲変更
const CastDataContext = createContext()
export const useCastData =()=>useContext(CastDataContext)

export default function CastDataProvider({children}){

    const [hvnId, setHvnId]=useState(null)

    const updateHvnId=(id)=>{
        setHvnId(id)

        return null
    }

    const resetHvnId=()=>{
        setHvnId(null)
        return null
    }


    return(
        <CastDataContext.Provider value={{
            hvnId,
            updateHvnId, resetHvnId,
        }}>
            {children}
        </CastDataContext.Provider>
    )
}